export {default as ConfigTemplateAuthorize} from './config-template-authorize'
